// helpers/sortHelpers.ts

/**
 * Trie un tableau d'objets par une propriété de type date (string | Date)
 * @param items - Tableau d'objets à trier
 * @param getDate - Fonction qui extrait la date de l'objet
 * @param order - 'desc' pour plus récent d'abord, 'asc' pour plus ancien d'abord
 * @returns Nouveau tableau trié
 */
export const sortByDate = <T>(items: T[], getDate: (item: T) => string | Date, order: "asc" | "desc" = "desc"): T[] => {
  return [...items].sort((a, b) => {
    const dateA = new Date(getDate(a)).getTime();
    const dateB = new Date(getDate(b)).getTime();

    return order === "desc" ? dateB - dateA : dateA - dateB;
  });
};

/**
 * Trie un tableau d'objets par une propriété numérique
 * @param items - Tableau d'objets à trier
 * @param getValue - Fonction qui extrait la valeur numérique de l'objet
 * @param order - 'desc' pour plus grand d'abord, 'asc' pour plus petit d'abord
 * @returns Nouveau tableau trié
 */
export const sortByNumber = <T>(items: T[], getValue: (item: T) => number, order: "asc" | "desc" = "desc"): T[] => {
  return [...items].sort((a, b) => {
    const valA = getValue(a);
    const valB = getValue(b);

    return order === "desc" ? valB - valA : valA - valB;
  });
};

/**
 * Trie un tableau d'objets par une propriété texte
 * @param items - Tableau d'objets à trier
 * @param getString - Fonction qui extrait la chaîne de l'objet
 * @param order - 'desc' pour Z à A, 'asc' pour A à Z
 * @returns Nouveau tableau trié
 */
export const sortByString = <T>(items: T[], getString: (item: T) => string, order: "asc" | "desc" = "asc"): T[] => {
  return [...items].sort((a, b) => {
    const strA = getString(a).toLowerCase();
    const strB = getString(b).toLowerCase();

    if (order === "asc") {
      return strA.localeCompare(strB);
    } else {
      return strB.localeCompare(strA);
    }
  });
};
